export default {"src":"/_next/static/media/vulnerability-analysis.5153f369.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};